import { FC, useLayoutEffect, useState } from 'react';
import { format } from 'date-fns';

import { setScrollToTime } from '@/apps/mwd-v2/state/actions/scrollToTime';
import useMwdTimescale from '@/apps/mwd-v2/state/selectors/useMwdTimescale';
import { Button } from '@/components/UI/Button/Button';
import { Tooltip } from '@/components/UI/Tooltip/Tooltip';
import useClientState from '@/state/useClientState';

import './ClockButton.module.css';

const TimeIndication: FC = () => {
  const { scale } = useMwdTimescale();
  const [time, setTime] = useState<string>(format(new Date(), 'H:mm'));
  const v2_dagovergang = useClientState((state) => state.v2_dagovergang);
  const miniMwdDagOvergang = useClientState((state) => state.miniMwdDagOvergang);
  useLayoutEffect(() => {
    const timeInterval = setInterval(() => {
      setTime((prevTime) => {
        const newTime = format(new Date(), 'H:mm');
        if (prevTime === '23:59' && ['0:00', '00:00'].includes(newTime)) {
          // reset grid with new timescale
          v2_dagovergang();
          miniMwdDagOvergang();
        }
        return newTime;
      });
    }, 1_000);
    return () => {
      clearInterval(timeInterval);
    };
  }, []);

  const handleOnClick = () => {
    const x = scale(new Date());
    setScrollToTime(x);
  };

  return (
    <Tooltip content='Ga naar het nu'>
      <Button data-testid='current-time-button' variant='outline' size='medium' onClick={handleOnClick}>
        {time}
      </Button>
    </Tooltip>
  );
};
export default TimeIndication;
